import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const tok = localStorage.getItem("mc68_token");
    if (!tok) {
      setUser(null);
      setReady(true);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
      localStorage.removeItem("mc68_token");
    }
    setReady(true);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginWithToken = (token, user) => {
    localStorage.setItem("mc68_token", token);
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("mc68_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, refresh, loginWithToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
